// T-170 Fase 1d — Helper puri per il tray di cattura multi-pagina.
// Nessun I/O: aggiunta/rimozione/riordino pagine + euristica qualità.
// Testabili in isolamento (captureTray.test.ts).

/** Cap pagine per documento — deve combaciare col MAX_PAGES del worker (1c). */
export const MAX_PAGES = 8;

export interface CapturedPage {
  /** id locale stabile (per key/reorder). */
  id: string;
  /** base64 dell'immagine (data URL o raw). */
  b64: string;
  mime: string;
  /** byte approssimati (per euristica qualità). */
  bytes: number;
}

export type PageQuality = 'ok' | 'too_small';

/**
 * Euristica leggera lato client: un'immagine molto piccola è quasi sempre
 * troppo scura/sfocata/vuota (poco dettaglio → poco peso). Non è un blur-detector
 * vero (servirebbe il canvas), ma intercetta gli scatti palesemente inutili
 * prima dell'upload. Soglia conservativa: < 30 KB.
 */
export function assessPageQuality(page: Pick<CapturedPage, 'bytes'>): PageQuality {
  return page.bytes < 30_000 ? 'too_small' : 'ok';
}

/** Aggiunge una pagina rispettando il cap. Ritorna la nuova lista (immutabile). */
export function addPage(pages: CapturedPage[], page: CapturedPage): CapturedPage[] {
  if (pages.length >= MAX_PAGES) return pages;
  return [...pages, page];
}

/** Quante pagine ancora aggiungibili. */
export function remainingSlots(pages: CapturedPage[]): number {
  return Math.max(0, MAX_PAGES - pages.length);
}

/** Rimuove la pagina per id. */
export function removePage(pages: CapturedPage[], id: string): CapturedPage[] {
  return pages.filter((p) => p.id !== id);
}

/**
 * Sposta la pagina dall'indice `from` all'indice `to` (riordino drag).
 * Indici fuori range → lista invariata.
 */
export function reorderPages(pages: CapturedPage[], from: number, to: number): CapturedPage[] {
  if (from < 0 || from >= pages.length || to < 0 || to >= pages.length || from === to) {
    return pages;
  }
  const next = [...pages];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}
